import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";

export const addCoins = async (body: { name: string, quantity: string, isBonus: boolean, destinationAccountName: string, senderName: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/addC`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }


    return result
}

export const addPromo = async (body: { name: string, quantity: string, bonus: number, destinationAccountName: string, senderName: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/addwithpromoC`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }

    return result
}

export const subtractCoins = async (body: { name: string, quantity: string, }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/subtractC`, body, config)
        result = response
    } catch (error: any) {
        result = error;
    }

    return result
}

export const checkIfPromoUserHasPhone = async (user: string): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.get(`/checkIfPromoUserHasPhone?platformUser=${user}`, config)
        result = response
    } catch (error: any) {
        result = error;
    }

    return result
}


export const updateUserInPromo = async (body: { platformUser: string, phone: string, firstName: string, lastName: string, firstLoadValue: number }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.patch('/updateUserInPromo', body, config)
        result = response
    } catch (error: any) {
        result = error;
    }

    return result
}


